import React from "react";
export default function Loader() {
    return (<div className="flex justify-center items-center relative">
      <div className="flex items-center justify-center">
        <div className="flex space-x-2 text-current z-10">
          <div className="w-2.5 h-2.5 rounded-full bg-current opacity-30" style={{
            animation: "loading-dots 1s infinite ease-in-out alternate",
            animationDelay: "0s",
        }}></div>
          <div className="w-2.5 h-2.5 rounded-full bg-current opacity-30" style={{
            animation: "loading-dots 1s infinite ease-in-out alternate",
            animationDelay: "0.5s",
        }}></div>
          <div className="w-2.5 h-2.5 rounded-full bg-current opacity-30" style={{
            animation: "loading-dots 1s infinite ease-in-out alternate",
            animationDelay: "1s",
        }}></div>
        </div>
      </div>
    </div>);
}
